import React, { useEffect, useState } from "react";
import OffCanvas from "../../../components/offCanvas";
import { EditCommunication } from "./CommunicationPreferences/EditCommunication";
import { EditPersonalDetails } from "./Personal/EditPersonalDetails";
import { useLocation, useParams } from "react-router-dom";
import { createPatientApi } from "../../../api-helpers/PatientApiHelper";
import { PatientPersonalInfo } from "patients-experience-client";
import { Personal } from "./Personal/Personal";
import { CommunicationPreferences } from "./CommunicationPreferences/CommunicationPreferences";
import { Pathway } from "./Pathway/Pathway";
import { Contact } from "./Contact/Contact";
import { Devices, } from "./Devices/Devices";
import { WellinksCareTeam } from "./WellinksCareTeam/WellinksCareTeam";
import { PatientInsurance } from "./Insurance/Insurance";
import { useDispatch } from "react-redux";
import { setPageTitle } from "../../../store/slices/pageTitleSlice";

export const PatientInfo = () => {
    const { patientId } = useParams<{ patientId: string }>();

    const [offCanvasTitle, setOffCanvasTitle] = useState("");
    const [offCanvasShow, setOffCanvasShow] = useState(false);
    const [loading, setLoading] = useState(true);
    const [offCanvasComp, setOffCanvasComp] = useState("");
    const patientApi= createPatientApi();
    const [patientInfo , setPatientInfo] = useState<PatientPersonalInfo>();
    const location = useLocation();

    const dispatch = useDispatch();
    useEffect(()=>{
        dispatch(setPageTitle('Patient Info: Patient Profile | Spire360'));
        if(patientId){
            getPatientInfo(patientId);
            getInternalCoaches(patientId);
        }
    },[])

    const getPatientInfo = async (patientId: string) => {
        setLoading(true);
        patientId = location.pathname.split("/")[2];
        try {
          const response = await patientApi.patientsControllerGetPatientPersonalInfo(patientId);
          setPatientInfo(response.data);
        } catch (error) {
          console.log(error);
        } finally {
            setLoading(false);
        }
      };

    
    const getInternalCoaches = async (patientId: string) => {
        try {
          const response = await patientApi.patientsControllerGetInternalCareTeam(patientId);
          //setInternalCoaches(response.data);

        } catch (error) {
          console.log(error);
        }
      };

    const handleOffCanvasShow = (comp: string) => {
        if (comp === "editCommunication") {
            setOffCanvasTitle("Edit Communication Preferences");
        }
        if (comp === "editPersonalDetails") {
            setOffCanvasTitle("Edit Personal Details");
        }
        setOffCanvasComp(comp);
        setOffCanvasShow(!offCanvasShow);
    };

    return (
        <>
        <div className="tabs__content">
            <div className="row">
                <div className="col-12 col-md-12 col-lg-12">
            <div className='border rounded-3 p-4'>
                <div className="rounded-3 p-5 bg-gray-FAF">
                    <div className="rounded-3 p-4 bg-white">
                        <Personal loading={loading} patientInfo={patientInfo} handleOffCanvasShow={handleOffCanvasShow} />
                    </div>
                </div>
                <div className="rounded-3 p-5 bg-gray-FAF mt-6 mb-6">
                    <div className="rounded-3 p-4 bg-white">
                        <Contact patientId={patientId} />
                    </div>
                </div>
                <div className="row g-2">
                    <div className="col-12 col-md-12 col-lg-12 col-xl-6 pe-3">
                        <div className="rounded-3 p-5 bg-gray-FAF">
                            <div className="rounded-3 p-4 bg-white">
                                <CommunicationPreferences loading={loading} patientInfo={patientInfo} handleOffCanvasShow={handleOffCanvasShow} />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-12 col-xl-6 ps-3">
                    <div className="rounded-3 p-5 bg-gray-FAF">
                            <div className="rounded-3 p-4 bg-white">
                                <WellinksCareTeam patientId={patientId} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row g-2 mt-4 mb-4">
                    <div className="col-12 col-md-12 col-lg-12 col-xl-6 pe-3">
                        <div className="rounded-3 p-5 bg-gray-FAF">
                            <div className="rounded-3 p-4 bg-white">
                                <Pathway patientInfo={patientInfo} />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-12 col-xl-6 ps-3">
                        <div className="rounded-3 p-5 bg-gray-FAF">
                            <div className="rounded-3 p-4 bg-white">
                                <Devices patientId={patientId}/>
                            </div>
                        </div>
                    </div>
                </div>
                    <div className="rounded-3 p-5 bg-gray-FAF">
                        <div className="rounded-3 p-4 bg-white">
                            <PatientInsurance patientInfo={patientInfo} />
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <OffCanvas
            title={offCanvasTitle}
            offCanvasShow={offCanvasShow}
            setOffCanvasShow={setOffCanvasShow}
            offCanvasComp={offCanvasComp}
        >
            {offCanvasComp === "editCommunication" && (
                <EditCommunication loading={(load: boolean) => setLoading(load)} loadPersonalDetails={getPatientInfo} patientInfo={patientInfo} setOffCanvasShow={setOffCanvasShow} />
            )}
            {offCanvasComp === "editPersonalDetails" && (
                <EditPersonalDetails loading={(load: boolean) => setLoading(load)} loadPersonalDetails={getPatientInfo} patientInfo={patientInfo} setOffCanvasShow={setOffCanvasShow} />
            )}
        </OffCanvas>
        </>
    )
}